function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12 6h-2c-1.1 0-2 .9-2 2s.9 2 2 2h2V6z"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M12 10h-2c-1.1 0-2 .9-2 2s.9 2 2 2h2v-4z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12 14h-2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2v-2z"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M12 6h2c1.1 0 2 .9 2 2s-.9 2-2 2h-2V6z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14 10c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2z"
})));